<mat-dialog-content>
	<app-loader
		[enableCircle]="true"
		[isActive]="isLoading"
		[width]="20"
	></app-loader>
	<div class="searchWrapper flex flex-shrink-0 flex-col justify-stretch">
		<div class="searchInput flex flex-col items-start justify-center px-2">
			<mat-form-field
				appearance="fill"
				class="mat-form-field-compact mat-form-field-no-hint w-full"
			>
				<input
					[formControl]="searchinput"
					cdkFocusInitial
					ignoreAutocomplete
					matInput
					tabindex="0"
					type="text"
				>
				<div
					class="flex-center h-full"
					matSuffix
				>
					<mat-icon inline>search</mat-icon>
				</div>
			</mat-form-field>
		</div>
		<ng-container *ngIf="this.data$filtered | async as tasks">
			<cdk-virtual-scroll-viewport
				[maxBufferPx]="800"
				[minBufferPx]="300"
				[style.height.px]="380"
				itemSize="40"
			>
				<mat-list
					*ngIf="tasks.length; else noTasksFound"
					class="pb-8"
					dense
					role="listbox"
				>
					<ng-container
						*cdkVirtualFor="let entry of tasks; let last = last; let first = first; trackBy: trackId"
					>
						<tg-task-picker-entry
							(select)="onSelect($event)"
							[entry]="entry"
						>
							<ng-template #entryMenu>
								<button
									[matMenuTriggerData]="{ $implicit: entry }"
									[matMenuTriggerFor]="taskContextMenu"
									class="!-ml-2"
									mat-icon-button
								>
									<mat-icon>more_vert</mat-icon>
								</button>
							</ng-template>
						</tg-task-picker-entry>
					</ng-container>
				</mat-list>
				<ng-template #noTasksFound>
					<p
						class="mat-hint flex h-full items-center justify-center text-center text-sm"
						translate
					>
						task.none-found
					</p>
				</ng-template>
			</cdk-virtual-scroll-viewport>
		</ng-container>
	</div>
</mat-dialog-content>
<mat-dialog-actions
	[matTooltip]="'workspace.errors.admin-create-task' | translate"
	[matTooltipDisabled]="this.workspace$canManageTask.value$ | async"
	class="mat-action-filled"
>
	<button
		(click)="createTaskDialog()"
		[disabled]="isLoading"
		*ngIf="workspace$canManageTask.value$ | async"
		class="mat-button-filled"
		color="primary"
		mat-flat-button
	>
		{{ 'task.add' | translate }}
	</button>
</mat-dialog-actions>
<div
	[matMenuTriggerFor]="taskContextMenu"
	[style.left]="contextMenuPosition.x"
	[style.top]="contextMenuPosition.y"
	#contextMenuTrigger="matMenuTrigger"
	style="visibility: hidden; position: fixed"
></div>
<mat-menu #taskContextMenu="matMenu">
	<ng-template
		let-task
		matMenuContent
	>
		<div class="flex flex-col gap-1">
			<a
				[routerLink]="['/settings/projects', task.project.id]"
				*ngIf="task.project?.id"
				mat-menu-item
				matDialogClose
			>
				<mat-icon inline>open_in_new </mat-icon>
				{{ 'project.open' | translate }}
			</a>
		</div>
	</ng-template>
</mat-menu>
